import React from 'react';
import { Icon } from '../UI';
import moment from 'moment/moment';
import { DateRange, Range, RangeKeyDict } from 'react-date-range';
import { useThemeContext } from '../../context/Theme';

interface CalendarRangeProps {
  goBack: () => void;
  handleDateRangeChange: ((rangesByKey: RangeKeyDict) => void) | undefined;
  ranges: Range[];
  startDate: Date;
  endDate: Date;
}

const CalendarRange: React.FC<CalendarRangeProps> = ({
  goBack,
  handleDateRangeChange,
  ranges,
  startDate,
  endDate,
}) => {
  const { theme } = useThemeContext();

  return (
    <div className="flex flex-col">
      <div className="flex justify-between p-2">
        <div
          className="flex items-center gap-2 cursor-pointer ml-2 mr-8"
          onClick={goBack}
        >
          <Icon svgName="arrowBack" />
          <span>Back</span>
        </div>
        <div className="flex border-b-2 gap-6 items-center border-grey-70">
          <span>
            {moment(startDate).format('YYYY/MM/DD')}-
            {moment(endDate).format('YYYY/MM/DD')}
          </span>
          <Icon svgName="cal" />
        </div>
      </div>
      <DateRange
        className="w-full"
        classNames={{
          month: 'flex-1',
        }}
        months={1}
        ranges={ranges}
        onChange={handleDateRangeChange}
        direction="horizontal"
        color={theme === 'DARK' ? '#404044' : '#B7FF00'}
        rangeColors={[theme === 'DARK' ? '#404044' : '#B7FF00']}
        maxDate={new Date()}
      />
    </div>
  );
};

export default CalendarRange;
